import * as _ from "../../../util/lodash";
import React from 'react';
import BaseToolbar from "./base-toolbar";
import { compose, defaultProps, setDisplayName, withProps } from 'react-recompose';
import { removeProps } from "../../core/hoc";
import { colors, icons, sizes, textAlignments } from "../../../enums";
import Button from "../../core/button";
var SimpleToolbar = compose(setDisplayName('SimpleToolbar'), removeProps(['tabMenu']), defaultProps({
  hasBorder: false
}), withProps(function (props) {
  return {
    actions: /*#__PURE__*/React.createElement(Button.Secondary, {
      icon: icons.CANCEL,
      color: colors.WHITE,
      size: sizes.X7,
      isCompact: true,
      onClick: props.onClose || _.noop
    }),
    areActionsDivided: false,
    isIconDivided: false,
    textAlign: textAlignments.CENTER,
    toolbarType: 'simple'
  };
}))(BaseToolbar);
export default SimpleToolbar;
//# sourceMappingURL=simple-toolbar.js.map